// <auto-generated>
// Generated from ../Solution.Backend/DAO/Analytics/AnalyticsCatalog.cs by scripts/generate-analytics-contracts.mjs.
// Do not edit — run `npm run generate:analytics` after backend catalog changes.
// </auto-generated>

import type { Base64, JsonDecimal, JsonInt64, SqlDate, SqlDateTime, Uuid } from './analytics';
import type { IsoDateTime } from './common';

/** api.ActiveSubscriptions (table) — GET /api/analytics/active-subscriptions */
export interface ActiveSubscriptionDto {
  teamId: string | null;
  subscriptionPlanId: string | null;
  activatedAt: string | null;
  expiresAfter: string | null;
  isSelfSignup: number | null;
  licenses: number | null;
}

/** api.AppEdits (table) — GET /api/analytics/app-edits */
export interface AppEditDto {
  appId: string | null;
  editedAt: string | null;
}

/** api.AppInvitations (table) — GET /api/analytics/app-invitations */
export interface AppInvitationDto {
  appId: string | null;
  email: string | null;
  assignment: string | null;
  role: string | null;
  teamRole: string | null;
  isPending: number | null;
  createdAt: string | null;
  acceptedInvitationAt: string | null;
}

/** api.Apps (table) — GET /api/analytics/apps */
export interface AnalyticsAppDto {
  id: string | null;
  teamId: string | null;
  creatorId: string | null;
  createdAt: SqlDateTime | null;
  updatedAt: SqlDateTime | null;
  name: string | null;
  description: string | null;
  publishMode: string | null;
  isHidden: boolean | null;
  isCopyable: boolean | null;
  hasWebhooks: boolean | null;
  hasTermsOfUse: boolean | null;
  wizardTemplate: string | null;
  wizardVersion: string | null;
  dataSource: string | null;
  isFromSampleFile: boolean | null;
  origin: string | null;
}

/** api.Creators (table) — GET /api/analytics/creators */
export interface CreatorDto {
  id: string | null;
  createdAt: SqlDateTime | null;
  email: string | null;
  emailIsConfirmed: boolean | null;
  name: string | null;
  language: string | null;
  creatorSince: SqlDateTime | null;
}

/** api.HubApps (table) — GET /api/analytics/hub-apps */
export interface HubAppDto {
  hubId: string | null;
  appId: string | null;
}

/** api.Hubs (table) — GET /api/analytics/hubs */
export interface HubDto {
  id: string | null;
  name: string | null;
  description: string | null;
  teamId: string | null;
  creatorId: string | null;
  publishMode: string | null;
}

/** api.Subscriptions (table) — GET /api/analytics/subscriptions */
export interface AnalyticsSubscriptionDto {
  teamId: string | null;
  subscriptionPlanId: string | null;
  activatedAt: string | null;
  expiresAfter: string | null;
  isSelfSignup: number | null;
  licenses: number | null;
}

/** api.TeamFeatures (table) — GET /api/analytics/team-features */
export interface TeamFeatureDto {
  teamId: string | null;
  feature: string | null;
}

/** api.TeamMembers (table) — GET /api/analytics/team-members */
export interface TeamMemberDto {
  teamId: string | null;
  email: string | null;
  role: string | null;
  isPending: number | null;
  createdAt: string | null;
  accountCreatedAt: string | null;
  lastClientUsage: string | null;
  acceptedInvitationAt: string | null;
}

/** api.Teams (table) — GET /api/analytics/teams */
export interface TeamDto {
  id: string | null;
  createdAt: SqlDateTime | null;
  name: string | null;
  email: string | null;
}

/** bi.AppCatalog (table) — GET /api/analytics/bi/app-catalog */
export interface BiAppCatalogDto {
  appId: Uuid;
  appName: string | null;
  firstSeenAt: SqlDateTime;
  lastSeenAt: SqlDateTime;
}

/** bi.AppEvent (table) — GET /api/analytics/bi/app-event */
export interface BiAppEventDto {
  eventTime: SqlDateTime;
  eventId: Uuid;
  sourceId: number;
  eventTypeId: number;
  appId: Uuid | null;
  userId: Uuid | null;
  subscriptionId: Uuid | null;
  subscriptionPlanId: string | null;
  userKey: string | null;
  sessionKey: string | null;
  platform: string | null;
  osName: string | null;
  osVersion: string | null;
  deviceModel: string | null;
  appVersion: string | null;
  country: string | null;
  city: string | null;
  locale: string | null;
  host: string | null;
  currentPage: string | null;
  actionType: string | null;
  elementType: string | null;
  ingestedAt: SqlDateTime;
}

/** bi.AppUsageDaily (table) — GET /api/analytics/bi/app-usage-daily */
export interface BiAppUsageDailyDto {
  usageDate: SqlDate;
  sourceId: number;
  appId: Uuid;
  userId: Uuid;
  subscriptionId: Uuid;
  subscriptionPlanId: string | null;
  platform: string;
  country: string;
  opens: number;
  actions: number;
  previews: number;
  edits: number;
  adminViews: number;
  dataLoads: number;
  installs: number;
  uninstalls: number;
  otherEvents: number;
  uniqueUsers: number;
  uniqueSessions: number;
}

/** bi.AppUsageMonthly (table) — GET /api/analytics/bi/app-usage-monthly */
export interface BiAppUsageMonthlyDto {
  usageMonth: SqlDate;
  sourceId: number;
  appId: Uuid;
  userId: Uuid;
  subscriptionId: Uuid;
  subscriptionPlanId: string | null;
  platform: string;
  opens: number;
  actions: number;
  previews: number;
  edits: number;
  adminViews: number;
  dataLoads: number;
  installs: number;
  uninstalls: number;
  otherEvents: number;
  uniqueUsers: number;
  uniqueSessions: number;
  activeDays: number;
}

/** bi.EventType (table) — GET /api/analytics/bi/event-type */
export interface BiEventTypeDto {
  eventTypeId: number;
  name: string;
  category: string;
  firstSeenAt: SqlDateTime;
}

/** bi.PreviewInteractionDaily (table) — GET /api/analytics/bi/preview-interaction-daily */
export interface BiPreviewInteractionDailyDto {
  usageDate: SqlDate;
  sourceId: number;
  appId: Uuid;
  userKey: string;
  sessionKey: string;
  userId: Uuid | null;
  subscriptionId: Uuid | null;
  subscriptionPlanId: string | null;
  platform: string | null;
  country: string | null;
  interactions: number;
  firstAt: SqlDateTime;
  lastAt: SqlDateTime;
}

/** bi.vw_AppEvent (view) — GET /api/analytics/bi/vw-app-event */
export interface BiVwAppEventDto {
  eventTime: SqlDateTime;
  eventDate: SqlDate | null;
  eventId: Uuid;
  source: string;
  eventName: string;
  eventCategory: string;
  appId: Uuid | null;
  appName: string | null;
  userId: Uuid | null;
  subscriptionId: Uuid | null;
  subscriptionPlanId: string | null;
  userKey: string | null;
  sessionKey: string | null;
  platform: string | null;
  osName: string | null;
  osVersion: string | null;
  deviceModel: string | null;
  appVersion: string | null;
  country: string | null;
  city: string | null;
  locale: string | null;
  host: string | null;
  currentPage: string | null;
  actionType: string | null;
  elementType: string | null;
  ingestedAt: SqlDateTime;
}

/** bi.vw_AppUsageDaily (view) — GET /api/analytics/bi/vw-app-usage-daily */
export interface BiVwAppUsageDailyDto {
  usageDate: SqlDate;
  source: string;
  appId: Uuid;
  appName: string | null;
  userId: Uuid | null;
  subscriptionId: Uuid | null;
  subscriptionPlanId: string | null;
  platform: string;
  country: string;
  opens: number;
  actions: number;
  previews: number;
  edits: number;
  adminViews: number;
  dataLoads: number;
  installs: number;
  uninstalls: number;
  otherEvents: number;
  uniqueUsers: number;
  uniqueSessions: number;
}

/** bi.vw_AppUsageMonthly (view) — GET /api/analytics/bi/vw-app-usage-monthly */
export interface BiVwAppUsageMonthlyDto {
  usageMonth: SqlDate;
  source: string;
  appId: Uuid;
  appName: string | null;
  userId: Uuid | null;
  subscriptionId: Uuid | null;
  subscriptionPlanId: string | null;
  platform: string;
  opens: number;
  actions: number;
  previews: number;
  edits: number;
  adminViews: number;
  dataLoads: number;
  installs: number;
  uninstalls: number;
  otherEvents: number;
  uniqueUsers: number;
  uniqueSessions: number;
  activeDays: number;
}

/** bi.vw_PreviewInteractionDaily (view) — GET /api/analytics/bi/vw-preview-interaction-daily */
export interface BiVwPreviewInteractionDailyDto {
  usageDate: SqlDate;
  source: string;
  appId: Uuid;
  appName: string | null;
  userId: Uuid | null;
  subscriptionId: Uuid | null;
  subscriptionPlanId: string | null;
  userKey: string;
  sessionKey: string;
  platform: string | null;
  country: string | null;
  interactions: number;
  firstAt: SqlDateTime;
  lastAt: SqlDateTime;
}

/** biapp.UserCredentials (table) — GET /api/analytics/biapp/user-credentials */
export interface BiappUserCredentialsDto {
  userId: Uuid;
  normalizedEmail: string;
}

/** biapp.Users (table) — GET /api/analytics/biapp/users */
export interface BiappUsersDto {
  id: Uuid;
  email: string;
  displayName: string;
  createdAt: IsoDateTime;
}

/** dbo.AppFeatures (table) — GET /api/analytics/dbo/app-features */
export interface DboAppFeaturesDto {
  appId: Uuid;
  feature: string;
  count: number;
}

/** dbo.AppSizes (table) — GET /api/analytics/dbo/app-sizes */
export interface DboAppSizesDto {
  appId: Uuid;
  deviceId: string;
  startDate: IsoDateTime;
  dataSize: JsonInt64;
}

/** dbo.AppUsage (table) — GET /api/analytics/dbo/app-usage */
export interface DboAppUsageDto {
  appId: Uuid;
  startDate: SqlDateTime;
  anonymizedUserId: string;
  osName: string;
  country: string;
  locale: string;
  openTotal: number;
  host: string | null;
}

/** dbo.NativeUsageLast30Days (view) — GET /api/analytics/dbo/native-usage-last30-days */
export interface DboNativeUsageLast30DaysDto {
  appId: Uuid;
  opensLast30Days: number | null;
  usersLast30Days: JsonInt64 | null;
  since: IsoDateTime | null;
}

/** dbo.Resources (table) — GET /api/analytics/dbo/resources */
export interface DboResourcesDto {
  id: Uuid;
  name: string | null;
  description: string | null;
  configuration: string | null;
  spreadsheetUrl: string | null;
  cardDefinitions: string | null;
  resourceDefinitions: string | null;
  keywords: string | null;
  isPrivate: boolean;
  isHidden: boolean;
  creatorId: Uuid;
  discriminator: string;
  helpPage: string | null;
  isPrototype: boolean;
  origin: string | null;
  botEnabled: boolean | null;
  isCopyable: boolean | null;
  dynamicSheet: string | null;
  webhooks: string | null;
  teamId: Uuid;
  createdAt: IsoDateTime;
  updatedAt: IsoDateTime | null;
  version: Base64;
  revision: Base64;
  termsOfUseUrl: string | null;
  privacyPolicyUrl: string | null;
  imprint: string | null;
  wizardVersion: string | null;
  disableOfflineMode: boolean | null;
  parentAppId: Uuid | null;
  isEnabledAIAgent: boolean;
  isTemplate: boolean | null;
}

/** dbo.SubscriptionPlans (table) — GET /api/analytics/dbo/subscription-plans */
export interface DboSubscriptionPlansDto {
  id: string;
  label: string | null;
  isCustom: boolean;
  createdAt: IsoDateTime;
  updatedAt: IsoDateTime | null;
  version: Base64;
  type: string | null;
}

/** dbo.Subscriptions (table) — GET /api/analytics/dbo/subscriptions */
export interface DboSubscriptionsDto {
  id: Uuid;
  userId: Uuid;
  subscriptionPlanId: string;
  activatedAt: IsoDateTime | null;
  expiresAfter: IsoDateTime | null;
  licenses: number | null;
  stripeSubscriptionId: string | null;
  createdAt: IsoDateTime;
  updatedAt: IsoDateTime | null;
  version: Base64;
  paymentInterval: string | null;
  paymentProviderId: string;
  isTrial: boolean | null;
  isConverted: boolean | null;
  subscriptionStatus: string | null;
  countOfTrial: number | null;
  startSubscriptionState: IsoDateTime | null;
  endSubscriptionState: IsoDateTime | null;
  isEnabledAIAgent: boolean;
}

/** dbo.Teams (table) — GET /api/analytics/dbo/teams */
export interface DboTeamsDto {
  id: Uuid;
  createdAt: IsoDateTime;
  updatedAt: IsoDateTime | null;
  version: Base64;
  creatorId: Uuid;
  name: string | null;
}

/** dbo.TeamUsers (table) — GET /api/analytics/dbo/team-users */
export interface DboTeamUsersDto {
  id: Uuid;
  teamId: Uuid;
  userId: Uuid | null;
  userEmail: string | null;
  userName: string | null;
  role: string | null;
  createdAt: IsoDateTime;
  updatedAt: IsoDateTime | null;
  version: Base64;
  acceptedInvitationAt: IsoDateTime | null;
}

/** dbo.Users (table) — GET /api/analytics/dbo/users */
export interface DboUsersDto {
  id: Uuid;
  email: string;
  name: string | null;
  emailIsConfirmed: boolean;
  isSuperAdmin: boolean;
  isCommercial: boolean | null;
  failedLoginAttempts: number;
  language: string | null;
  locked: string | null;
  isCreator: boolean | null;
  stripeCustomerId: string | null;
  createdAt: IsoDateTime;
  updatedAt: IsoDateTime | null;
  version: Base64;
  invitedById: Uuid | null;
  companyName: string | null;
  firstName: string | null;
  lastName: string | null;
  utmParameters: string | null;
  isTest: boolean;
  isConverted: boolean;
  isManagementAccount: boolean;
  passwordChangedAtUtc: SqlDateTime | null;
  forceLogoutAtUtc: SqlDateTime | null;
  isEnabledAIAgent: boolean;
}

/** dbo.WebClientUsage_30Days (table) — GET /api/analytics/dbo/web-client-usage-30-days */
export interface DboWebClientUsage30DaysDto {
  appId: string | null;
  platform: string | null;
  users: number | null;
  sessions: number | null;
  averageSessionDuration: number;
}

/** dbo.WebClientUsage_Total (table) — GET /api/analytics/dbo/web-client-usage-total */
export interface DboWebClientUsageTotalDto {
  appId: string | null;
  platform: string | null;
  users: number | null;
  sessions: number | null;
  averageSessionDuration: number;
}

/** etl.DirtyDay (table) — GET /api/analytics/etl/dirty-day */
export interface EtlDirtyDayDto {
  usageDate: SqlDate;
}

/** etl.EventCategoryRule (table) — GET /api/analytics/etl/event-category-rule */
export interface EtlEventCategoryRuleDto {
  pattern: string;
  category: string;
  priority: number;
}

/** etl.RunLog (table) — GET /api/analytics/etl/run-log */
export interface EtlRunLogDto {
  runLogId: JsonInt64;
  job: string;
  sourceId: number | null;
  windowStart: SqlDateTime | null;
  windowEnd: SqlDateTime | null;
  startedAt: SqlDateTime;
  finishedAt: SqlDateTime;
  rowsRead: number | null;
  rowsWritten: number | null;
  status: string;
  message: string | null;
}

/** etl.Source (table) — GET /api/analytics/etl/source */
export interface EtlSourceDto {
  sourceId: number;
  name: string;
  resourceId: string;
  defaultPlatform: string;
  isActive: boolean;
  loadFrom: SqlDateTime;
}

/** etl.vw_LoadStatus (view) — GET /api/analytics/etl/vw-load-status */
export interface EtlVwLoadStatusDto {
  sourceId: number;
  source: string;
  isActive: boolean;
  loadFrom: SqlDateTime;
  eventsLoadedUntil: SqlDateTime | null;
  previewNextDay: SqlDateTime | null;
  lastRunAt: SqlDateTime | null;
  lastStatus: string | null;
  lastMessage: string | null;
}

/** etl.Watermark (table) — GET /api/analytics/etl/watermark */
export interface EtlWatermarkDto {
  sourceId: number;
  job: string;
  value: SqlDateTime;
  updatedAt: SqlDateTime;
}

/** stripe.BalanceTransactions (table) — GET /api/analytics/stripe/balance-transactions */
export interface StripeBalanceTransactionsDto {
  id: string;
  additionalFieldsJson: string | null;
  amountMinor: JsonInt64;
  availableOn: SqlDateTime | null;
  created: SqlDateTime;
  currency: string | null;
  d365Id: Uuid | null;
  description: string | null;
  exchangeRate: JsonDecimal | null;
  feeDetailsJson: string | null;
  feeMinor: JsonInt64;
  hubSpotId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  netMinor: JsonInt64;
  oaaId: Uuid | null;
  reportingCategory: string | null;
  sourceId: string | null;
  status: string | null;
  type: string | null;
}

/** stripe.Charges (table) — GET /api/analytics/stripe/charges */
export interface StripeChargesDto {
  id: string;
  additionalFieldsJson: string | null;
  amountCapturedMinor: JsonInt64;
  amountMinor: JsonInt64;
  amountRefundedMinor: JsonInt64;
  balanceTransactionId: string | null;
  billingEmail: string | null;
  billingName: string | null;
  captured: boolean;
  cardBrand: string | null;
  cardCountry: string | null;
  cardLast4: string | null;
  created: SqlDateTime;
  currency: string | null;
  customerId: string | null;
  d365Id: Uuid | null;
  description: string | null;
  disputed: boolean;
  failureCode: string | null;
  failureMessage: string | null;
  hubSpotId: string | null;
  invoiceId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  paid: boolean;
  paymentIntentId: string | null;
  paymentMethodId: string | null;
  paymentMethodType: string | null;
  receiptNumber: string | null;
  receiptUrl: string | null;
  refunded: boolean;
  statementDescriptor: string | null;
  status: string | null;
  walletType: string | null;
  oaaUserId: Uuid | null;
}

/** stripe.Coupons (table) — GET /api/analytics/stripe/coupons */
export interface StripeCouponsDto {
  id: string;
  additionalFieldsJson: string | null;
  amountOffMinor: JsonInt64 | null;
  created: SqlDateTime;
  currency: string | null;
  d365Id: Uuid | null;
  duration: string | null;
  durationInMonths: number | null;
  hubSpotId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  maxRedemptions: JsonInt64 | null;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  name: string | null;
  oaaId: Uuid | null;
  percentOff: JsonDecimal | null;
  redeemBy: SqlDateTime | null;
  timesRedeemed: JsonInt64;
  valid: boolean;
}

/** stripe.Customers (table) — GET /api/analytics/stripe/customers */
export interface StripeCustomersDto {
  id: string;
  additionalFieldsJson: string | null;
  addressCity: string | null;
  addressCountry: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  addressPostalCode: string | null;
  addressState: string | null;
  balanceMinor: JsonInt64;
  created: SqlDateTime;
  currency: string | null;
  d365Id: Uuid | null;
  delinquent: boolean;
  description: string | null;
  email: string | null;
  hubSpotId: string | null;
  invoicePrefix: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  name: string | null;
  oaaId: Uuid | null;
  phone: string | null;
  taxExempt: string | null;
  oaaUserId: Uuid | null;
}

/** stripe.Discounts (table) — GET /api/analytics/stripe/discounts */
export interface StripeDiscountsDto {
  id: string;
  additionalFieldsJson: string | null;
  couponId: string | null;
  created: SqlDateTime;
  customerId: string | null;
  d365Id: Uuid | null;
  end: SqlDateTime | null;
  hubSpotId: string | null;
  invoiceId: string | null;
  invoiceItemId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  promotionCodeId: string | null;
  start: SqlDateTime | null;
  subscriptionId: string | null;
  oaaUserId: Uuid | null;
  oaaSubscriptionId: Uuid | null;
}

/** stripe.Disputes (table) — GET /api/analytics/stripe/disputes */
export interface StripeDisputesDto {
  id: string;
  additionalFieldsJson: string | null;
  amountMinor: JsonInt64;
  balanceTransactionId: string | null;
  chargeId: string | null;
  created: SqlDateTime;
  currency: string | null;
  d365Id: Uuid | null;
  evidenceDueBy: SqlDateTime | null;
  evidencePastDue: boolean;
  evidenceSubmissionCount: number;
  hasEvidence: boolean;
  hubSpotId: string | null;
  isChargeRefundable: boolean;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  paymentIntentId: string | null;
  reason: string | null;
  status: string | null;
}

/** stripe.Events (table) — GET /api/analytics/stripe/events */
export interface StripeEventsDto {
  id: string;
  additionalFieldsJson: string | null;
  apiVersion: string | null;
  created: SqlDateTime;
  d365Id: Uuid | null;
  hubSpotId: string | null;
  isDeletion: boolean;
  isMirrorable: boolean;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  oaaId: Uuid | null;
  payload: string | null;
  payloadId: string | null;
  payloadType: string | null;
  previousAttributes: string | null;
  type: string | null;
}

/** stripe.InvoiceCustomFields (table) — GET /api/analytics/stripe/invoice-custom-fields */
export interface StripeInvoiceCustomFieldsDto {
  id: number;
  d365Id: Uuid | null;
  invoiceId: string;
  name: string | null;
  value: string | null;
}

/** stripe.InvoiceLines (table) — GET /api/analytics/stripe/invoice-lines */
export interface StripeInvoiceLinesDto {
  id: string;
  additionalFieldsJson: string | null;
  amountMinor: JsonInt64;
  created: SqlDateTime;
  currency: string | null;
  d365Id: Uuid | null;
  description: string | null;
  discountAmountMinor: JsonInt64;
  discountIdsJson: string | null;
  discountable: boolean;
  hubSpotId: string | null;
  invoiceId: string | null;
  invoiceItemId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  periodEnd: SqlDateTime | null;
  periodStart: SqlDateTime | null;
  priceId: string | null;
  proration: boolean;
  quantity: JsonInt64 | null;
  subscriptionId: string | null;
  subscriptionItemId: string | null;
  type: string | null;
  oaaUserId: Uuid | null;
  oaaSubscriptionId: Uuid | null;
}

/** stripe.Invoices (table) — GET /api/analytics/stripe/invoices */
export interface StripeInvoicesDto {
  id: string;
  additionalFieldsJson: string | null;
  amountDueMinor: JsonInt64;
  amountPaidMinor: JsonInt64;
  amountRemainingMinor: JsonInt64;
  attemptCount: number;
  attempted: boolean;
  billingReason: string | null;
  chargeId: string | null;
  collectionMethod: string | null;
  created: SqlDateTime;
  currency: string | null;
  customerEmail: string | null;
  customerId: string | null;
  customerName: string | null;
  d365Id: Uuid | null;
  defaultTaxRateIdsJson: string | null;
  description: string | null;
  dueDate: SqlDateTime | null;
  finalizedAt: SqlDateTime | null;
  hostedInvoiceUrl: string | null;
  hubSpotId: string | null;
  invoicePdfUrl: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  markedUncollectibleAt: SqlDateTime | null;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  nextPaymentAttempt: SqlDateTime | null;
  number: string | null;
  oaaId: Uuid | null;
  paid: boolean;
  paidAt: SqlDateTime | null;
  paidOutOfBand: boolean;
  paymentIntentId: string | null;
  periodEnd: SqlDateTime | null;
  periodStart: SqlDateTime | null;
  status: string | null;
  subscriptionId: string | null;
  subtotalMinor: JsonInt64;
  taxMinor: JsonInt64 | null;
  totalDiscountAmountMinor: JsonInt64;
  totalMinor: JsonInt64;
  voidedAt: SqlDateTime | null;
  oaaUserId: Uuid | null;
  oaaSubscriptionId: Uuid | null;
}

/** stripe.Objects (table) — GET /api/analytics/stripe/objects */
export interface StripeObjectsDto {
  id: string;
  additionalFieldsJson: string | null;
  created: SqlDateTime;
  customerId: string | null;
  d365Id: Uuid | null;
  hubSpotId: string | null;
  lastSyncedAt: SqlDateTime;
  list: string;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  objectType: string;
  status: string | null;
  oaaUserId: Uuid | null;
}

/** stripe.PaymentIntents (table) — GET /api/analytics/stripe/payment-intents */
export interface StripePaymentIntentsDto {
  id: string;
  additionalFieldsJson: string | null;
  amountCapturableMinor: JsonInt64 | null;
  amountMinor: JsonInt64;
  amountReceivedMinor: JsonInt64;
  canceledAt: SqlDateTime | null;
  cancellationReason: string | null;
  captureMethod: string | null;
  confirmationMethod: string | null;
  created: SqlDateTime;
  currency: string | null;
  customerId: string | null;
  d365Id: Uuid | null;
  description: string | null;
  hubSpotId: string | null;
  invoiceId: string | null;
  lastSyncedAt: SqlDateTime;
  latestChargeId: string | null;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  paymentMethodId: string | null;
  receiptEmail: string | null;
  statementDescriptor: string | null;
  status: string | null;
  oaaUserId: Uuid | null;
}

/** stripe.Payouts (table) — GET /api/analytics/stripe/payouts */
export interface StripePayoutsDto {
  id: string;
  additionalFieldsJson: string | null;
  amountMinor: JsonInt64;
  arrivalDate: SqlDateTime | null;
  automatic: boolean;
  balanceTransactionId: string | null;
  created: SqlDateTime;
  currency: string | null;
  d365Id: Uuid | null;
  description: string | null;
  destinationId: string | null;
  failureBalanceTransactionId: string | null;
  failureCode: string | null;
  failureMessage: string | null;
  hubSpotId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  method: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  reconciliationStatus: string | null;
  sourceType: string | null;
  statementDescriptor: string | null;
  status: string | null;
  type: string | null;
}

/** stripe.Prices (table) — GET /api/analytics/stripe/prices */
export interface StripePricesDto {
  id: string;
  active: boolean;
  additionalFieldsJson: string | null;
  billingScheme: string | null;
  created: SqlDateTime;
  currency: string | null;
  d365Id: Uuid | null;
  hubSpotId: string | null;
  isFromCatalog: boolean;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  lookupKey: string | null;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  nickname: string | null;
  oaaId: Uuid | null;
  oaaPlanKey: string | null;
  productId: string | null;
  recurringInterval: string | null;
  recurringIntervalCount: JsonInt64 | null;
  recurringUsageType: string | null;
  taxBehavior: string | null;
  tiersMode: string | null;
  type: string | null;
  unitAmountDecimal: string | null;
  unitAmountMinor: JsonInt64 | null;
}

/** stripe.Products (table) — GET /api/analytics/stripe/products */
export interface StripeProductsDto {
  id: string;
  active: boolean;
  additionalFieldsJson: string | null;
  created: SqlDateTime;
  d365Id: Uuid | null;
  defaultPriceId: string | null;
  description: string | null;
  hubSpotId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  name: string | null;
  oaaId: Uuid | null;
  shippable: boolean | null;
  statementDescriptor: string | null;
  taxCode: string | null;
  type: string | null;
  unitLabel: string | null;
  updated: SqlDateTime | null;
  url: string | null;
}

/** stripe.Refunds (table) — GET /api/analytics/stripe/refunds */
export interface StripeRefundsDto {
  id: string;
  additionalFieldsJson: string | null;
  amountMinor: JsonInt64;
  balanceTransactionId: string | null;
  chargeId: string | null;
  created: SqlDateTime;
  currency: string | null;
  d365Id: Uuid | null;
  description: string | null;
  failureReason: string | null;
  hubSpotId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  paymentIntentId: string | null;
  reason: string | null;
  receiptNumber: string | null;
  status: string | null;
}

/** stripe.SubscriptionItems (table) — GET /api/analytics/stripe/subscription-items */
export interface StripeSubscriptionItemsDto {
  id: string;
  additionalFieldsJson: string | null;
  created: SqlDateTime;
  d365Id: Uuid | null;
  hubSpotId: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  priceId: string | null;
  quantity: JsonInt64 | null;
  subscriptionId: string | null;
  oaaUserId: Uuid | null;
  oaaSubscriptionId: Uuid | null;
}

/** stripe.Subscriptions (table) — GET /api/analytics/stripe/subscriptions */
export interface StripeSubscriptionsDto {
  id: string;
  additionalFieldsJson: string | null;
  billingCycleAnchor: SqlDateTime | null;
  cancelAt: SqlDateTime | null;
  cancelAtPeriodEnd: boolean;
  canceledAt: SqlDateTime | null;
  collectionMethod: string | null;
  created: SqlDateTime;
  currency: string | null;
  currentPeriodEnd: SqlDateTime | null;
  currentPeriodStart: SqlDateTime | null;
  customerId: string | null;
  d365Id: Uuid | null;
  daysUntilDue: number | null;
  defaultPaymentMethodId: string | null;
  defaultTaxRateIdsJson: string | null;
  description: string | null;
  endedAt: SqlDateTime | null;
  hubSpotId: string | null;
  lastSyncedAt: SqlDateTime;
  latestInvoiceId: string | null;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  scheduleId: string | null;
  startDate: SqlDateTime | null;
  status: string | null;
  trialEnd: SqlDateTime | null;
  trialStart: SqlDateTime | null;
  oaaUserId: Uuid | null;
  oaaSubscriptionId: Uuid | null;
}

/** stripe.TaxRates (table) — GET /api/analytics/stripe/tax-rates */
export interface StripeTaxRatesDto {
  id: string;
  active: boolean;
  additionalFieldsJson: string | null;
  country: string | null;
  created: SqlDateTime;
  d365Id: Uuid | null;
  description: string | null;
  displayName: string | null;
  hubSpotId: string | null;
  inclusive: boolean;
  jurisdiction: string | null;
  lastSyncedAt: SqlDateTime;
  liveMode: boolean;
  metadata: string | null;
  missingFromSourceSince: SqlDateTime | null;
  oaaId: Uuid | null;
  percentage: JsonDecimal;
  state: string | null;
  taxType: string | null;
}

/** Row type per resource; keys are `{schema}/{route segment}`. */
export interface AnalyticsRowMap {
  'api/active-subscriptions': ActiveSubscriptionDto;
  'api/app-edits': AppEditDto;
  'api/app-invitations': AppInvitationDto;
  'api/apps': AnalyticsAppDto;
  'api/creators': CreatorDto;
  'api/hub-apps': HubAppDto;
  'api/hubs': HubDto;
  'api/subscriptions': AnalyticsSubscriptionDto;
  'api/team-features': TeamFeatureDto;
  'api/team-members': TeamMemberDto;
  'api/teams': TeamDto;
  'bi/app-catalog': BiAppCatalogDto;
  'bi/app-event': BiAppEventDto;
  'bi/app-usage-daily': BiAppUsageDailyDto;
  'bi/app-usage-monthly': BiAppUsageMonthlyDto;
  'bi/event-type': BiEventTypeDto;
  'bi/preview-interaction-daily': BiPreviewInteractionDailyDto;
  'bi/vw-app-event': BiVwAppEventDto;
  'bi/vw-app-usage-daily': BiVwAppUsageDailyDto;
  'bi/vw-app-usage-monthly': BiVwAppUsageMonthlyDto;
  'bi/vw-preview-interaction-daily': BiVwPreviewInteractionDailyDto;
  'biapp/user-credentials': BiappUserCredentialsDto;
  'biapp/users': BiappUsersDto;
  'dbo/app-features': DboAppFeaturesDto;
  'dbo/app-sizes': DboAppSizesDto;
  'dbo/app-usage': DboAppUsageDto;
  'dbo/native-usage-last30-days': DboNativeUsageLast30DaysDto;
  'dbo/resources': DboResourcesDto;
  'dbo/subscription-plans': DboSubscriptionPlansDto;
  'dbo/subscriptions': DboSubscriptionsDto;
  'dbo/teams': DboTeamsDto;
  'dbo/team-users': DboTeamUsersDto;
  'dbo/users': DboUsersDto;
  'dbo/web-client-usage-30-days': DboWebClientUsage30DaysDto;
  'dbo/web-client-usage-total': DboWebClientUsageTotalDto;
  'etl/dirty-day': EtlDirtyDayDto;
  'etl/event-category-rule': EtlEventCategoryRuleDto;
  'etl/run-log': EtlRunLogDto;
  'etl/source': EtlSourceDto;
  'etl/vw-load-status': EtlVwLoadStatusDto;
  'etl/watermark': EtlWatermarkDto;
  'stripe/balance-transactions': StripeBalanceTransactionsDto;
  'stripe/charges': StripeChargesDto;
  'stripe/coupons': StripeCouponsDto;
  'stripe/customers': StripeCustomersDto;
  'stripe/discounts': StripeDiscountsDto;
  'stripe/disputes': StripeDisputesDto;
  'stripe/events': StripeEventsDto;
  'stripe/invoice-custom-fields': StripeInvoiceCustomFieldsDto;
  'stripe/invoice-lines': StripeInvoiceLinesDto;
  'stripe/invoices': StripeInvoicesDto;
  'stripe/objects': StripeObjectsDto;
  'stripe/payment-intents': StripePaymentIntentsDto;
  'stripe/payouts': StripePayoutsDto;
  'stripe/prices': StripePricesDto;
  'stripe/products': StripeProductsDto;
  'stripe/refunds': StripeRefundsDto;
  'stripe/subscription-items': StripeSubscriptionItemsDto;
  'stripe/subscriptions': StripeSubscriptionsDto;
  'stripe/tax-rates': StripeTaxRatesDto;
}

export type AnalyticsResourceKey = keyof AnalyticsRowMap;

/** API path per resource. */
export const ANALYTICS_RESOURCE_PATHS: Readonly<Record<AnalyticsResourceKey, string>> = {
  'api/active-subscriptions': '/api/analytics/active-subscriptions',
  'api/app-edits': '/api/analytics/app-edits',
  'api/app-invitations': '/api/analytics/app-invitations',
  'api/apps': '/api/analytics/apps',
  'api/creators': '/api/analytics/creators',
  'api/hub-apps': '/api/analytics/hub-apps',
  'api/hubs': '/api/analytics/hubs',
  'api/subscriptions': '/api/analytics/subscriptions',
  'api/team-features': '/api/analytics/team-features',
  'api/team-members': '/api/analytics/team-members',
  'api/teams': '/api/analytics/teams',
  'bi/app-catalog': '/api/analytics/bi/app-catalog',
  'bi/app-event': '/api/analytics/bi/app-event',
  'bi/app-usage-daily': '/api/analytics/bi/app-usage-daily',
  'bi/app-usage-monthly': '/api/analytics/bi/app-usage-monthly',
  'bi/event-type': '/api/analytics/bi/event-type',
  'bi/preview-interaction-daily': '/api/analytics/bi/preview-interaction-daily',
  'bi/vw-app-event': '/api/analytics/bi/vw-app-event',
  'bi/vw-app-usage-daily': '/api/analytics/bi/vw-app-usage-daily',
  'bi/vw-app-usage-monthly': '/api/analytics/bi/vw-app-usage-monthly',
  'bi/vw-preview-interaction-daily': '/api/analytics/bi/vw-preview-interaction-daily',
  'biapp/user-credentials': '/api/analytics/biapp/user-credentials',
  'biapp/users': '/api/analytics/biapp/users',
  'dbo/app-features': '/api/analytics/dbo/app-features',
  'dbo/app-sizes': '/api/analytics/dbo/app-sizes',
  'dbo/app-usage': '/api/analytics/dbo/app-usage',
  'dbo/native-usage-last30-days': '/api/analytics/dbo/native-usage-last30-days',
  'dbo/resources': '/api/analytics/dbo/resources',
  'dbo/subscription-plans': '/api/analytics/dbo/subscription-plans',
  'dbo/subscriptions': '/api/analytics/dbo/subscriptions',
  'dbo/teams': '/api/analytics/dbo/teams',
  'dbo/team-users': '/api/analytics/dbo/team-users',
  'dbo/users': '/api/analytics/dbo/users',
  'dbo/web-client-usage-30-days': '/api/analytics/dbo/web-client-usage-30-days',
  'dbo/web-client-usage-total': '/api/analytics/dbo/web-client-usage-total',
  'etl/dirty-day': '/api/analytics/etl/dirty-day',
  'etl/event-category-rule': '/api/analytics/etl/event-category-rule',
  'etl/run-log': '/api/analytics/etl/run-log',
  'etl/source': '/api/analytics/etl/source',
  'etl/vw-load-status': '/api/analytics/etl/vw-load-status',
  'etl/watermark': '/api/analytics/etl/watermark',
  'stripe/balance-transactions': '/api/analytics/stripe/balance-transactions',
  'stripe/charges': '/api/analytics/stripe/charges',
  'stripe/coupons': '/api/analytics/stripe/coupons',
  'stripe/customers': '/api/analytics/stripe/customers',
  'stripe/discounts': '/api/analytics/stripe/discounts',
  'stripe/disputes': '/api/analytics/stripe/disputes',
  'stripe/events': '/api/analytics/stripe/events',
  'stripe/invoice-custom-fields': '/api/analytics/stripe/invoice-custom-fields',
  'stripe/invoice-lines': '/api/analytics/stripe/invoice-lines',
  'stripe/invoices': '/api/analytics/stripe/invoices',
  'stripe/objects': '/api/analytics/stripe/objects',
  'stripe/payment-intents': '/api/analytics/stripe/payment-intents',
  'stripe/payouts': '/api/analytics/stripe/payouts',
  'stripe/prices': '/api/analytics/stripe/prices',
  'stripe/products': '/api/analytics/stripe/products',
  'stripe/refunds': '/api/analytics/stripe/refunds',
  'stripe/subscription-items': '/api/analytics/stripe/subscription-items',
  'stripe/subscriptions': '/api/analytics/stripe/subscriptions',
  'stripe/tax-rates': '/api/analytics/stripe/tax-rates',
};
